import { Component, OnInit } from '@angular/core';

import { UsersService } from '../users/users.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-navigation-links',
  templateUrl: './navigation-links.component.html',
  styleUrls: ['./navigation-links.component.scss']
})
export class NavigationLinksComponent implements OnInit {

  canAccessQC: boolean = false
  canAccessV4: boolean = false
  monorailV4URL = environment.monorailV4URL;

  constructor(private usersService: UsersService) { }

  ngOnInit() {
    this.usersService.profile.subscribe((profile) => {
      this.canAccessQC = profile.canAccessQC
      this.canAccessV4 = profile.canAccessV4
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/layouts/navigation-links.component.ts